module.exports = __webpack_public_path__ + "img/20_dice[19].00fabb3d.png";